import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { PawPrint } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Skip if user data was passed from AuthCallback
    if (location.state?.user) {
      return;
    }
    
    if (!loading && !user) {
      navigate("/", { replace: true });
    }
  }, [user, loading, navigate, location.state]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center" style={{ backgroundColor: '#FDFCF8' }}>
        <div className="animate-pulse-soft">
          <PawPrint size={48} className="text-[#E07A5F]" strokeWidth={2} />
        </div>
        <p className="mt-4 text-[#7D7F8C] font-medium">Caricamento...</p>
      </div>
    );
  }

  if (!user && !location.state?.user) {
    return null;
  }

  return children;
}
